const normalizeLines = (input) => {
  if (!input || typeof input !== 'string') return []

  return input
    // Convert block elements to line breaks
    .replace(/<\/?(div|p|li|ul|ol)[^>]*>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')

    // Remove remaining HTML
    .replace(/<[^>]*>/g, '')

    // Normalize spaces
    .replace(/\u00A0/g, ' ') // &nbsp;
    .replace(/\u200B/g, '')  // zero-width space

    // Split into lines
    .split('\n')
    .map(line => line.trim())

    // Remove bullets / numbering
    .map(line =>
      line.replace(/^(\s*[\u2022•\-\*\–]|\d+[\.\)])\s*/, '')
    )

    // Remove empty lines
    .filter(line => line.length > 0)
}

//
// 🔹 Convert to <li> items
//
export const toBulletItems = (input, itemStyle = '') => {
  const lines = normalizeLines(input)
  const styleAttribute = itemStyle ? ` style="${itemStyle}"` : ''
  return lines.map(line => `<li${styleAttribute}>${line}</li>`).join('')
}



//
// 🔹 Same as above but keeps intent clear for plain text
//
export const toBulletItemsFromBulletText = (input, itemStyle = '') => {
  return toBulletItems(input, itemStyle)
}

//
// 🔹 Render bullets (alias, no need separate logic)
//
export const renderBullets = (input, itemStyle = '') => {
  return toBulletItems(input, itemStyle)
}

//
// 🔹 Convert to full <ul>...</ul>
//
export const convertToBulletHtml = (input) => {
  if (!input) return ''

  if (input.includes('<li>')) return input                      

  const lines = normalizeLines(input)

  return lines.length
    ? `<ul style="                                                                              
        margin:0;
        padding-left:0;
        list-style:none;
      ">
        ${lines.map(line => `<li style="margin:0;">• ${line}</li>`).join('')}
       </ul>`
    : ''
}

//
// 🔹 Better content check (fixes &nbsp;, <br>, etc.)
//
// export const hasRealContent = (input) => {
//   return normalizeLines(input).length > 0
// }
 export const hasRealContent = (html) => {
          if (!html) return false
          return html.replace(/<[^>]*>/g, '').trim().length > 0
        }
